// /src/Context/TransferSearchContext.js
import React, { createContext, useContext, useState } from "react";

const TransferSearchContext = createContext();

export const useTransferSearch = () => useContext(TransferSearchContext);

export const TransferSearchProvider = ({ children }) => {
  const defaultData = {
    from: null,
    to: null,
    date: null,
    time: { hour: "", minute: "", ampm: "" },
    passengers: 1,
  };

  const [searchData, setSearchData] = useState(defaultData);
  const resetSearchData = () => {
    setSearchData(defaultData);
  };

  return (
    <TransferSearchContext.Provider  value={{ searchData, setSearchData, resetSearchData }}>
      {children}
    </TransferSearchContext.Provider>
  );
};
